import Rest2 from '../Services/Rest2'
import {store} from '../store/store'
/**
 * @typedef {PaymentService}
 */
export default class PaymentService  {

  constructor(){       
    this.resource = "/payment"
    this.http = Rest2.build( store.getters.token, this.resource);
    
  }

  static build(){    
    return new this;
  }

   /**
   * @param {Object} record
   * @returns {*|PromiseLike<T | never>|Promise<T | never>}
   */
  makePayment (record) {    
    return this.http.post('/make', record)
  }

  getServiceItems(product_id)  {    
    return this.http.get(`/product_service_items/${product_id}`);
  }

  getMyOrders(){
    return this.http.get('/myorders');
  }

  get_invoices(){
    return this.http.get('/invoice/all')
  }

  get_invoice(invoice_id){
    return this.http.get(`/invoice/${invoice_id}`);
  }
}